module.exports = __webpack_public_path__ + "static/media/15.033b81e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/15.jpg
// module id = 942
// module chunks = 0